import { namespaces, useSharedTranslation } from 'us-react-components/dist/hooks/useSharedTranslation';

import { DashboardBookingCard } from 'us-react-components/dist/DashboardBookingCard/DashboardBookingCard';
import { DateFormat, formatDateFromString, sameDay } from 'us-react-components/dist/utils/date';
import { Booking } from 'us-web-services';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/pro-solid-svg-icons/faAngleRight';
import { Routes } from '../../Routes';
import { Link } from '../Link';

type Props = {
  bookings: Booking[];
}

type LinkComponentProps = {
  booking: Booking;
}
const BookingLinkComponent = (linkComponentProps: LinkComponentProps): JSX.Element => {
  const { booking } = linkComponentProps;
  const { t } = useSharedTranslation(namespaces.caregiver);

  const isJobFinished = (): boolean => booking?.status?.code === 'job_finished';

  return isJobFinished() ?
    (<Link className='block py-1 my-1 font-bold text-sm' to={`/app${Routes.bookings.root}/${booking.id}/confirm-hours`} external>
      {t('pages.sitter.dashboard.bookings.confirmPayment')}
    </Link>) :
    (<Link className='block py-1 my-1 font-bold text-sm' to={`/app${Routes.bookings.root}/${booking.id}`} external>
      {t('pages.sitter.dashboard.bookings.viewDetails')}
    </Link>);
}

export const DashboardBookings = (props: Props): JSX.Element => {
  const { t } = useSharedTranslation(namespaces.caregiver);
  const getDateString = (booking: Booking): string => {
    const start = new Date(booking?.start || '');
    const end = new Date(booking?.end || '');
    if (sameDay(start, end)) {
      return `${formatDateFromString(booking?.start || '', DateFormat.DATETIME_WEEKDAY_FORMAT)}
        - ${formatDateFromString(booking?.end || '', DateFormat.TIME_FORMAT)}`
    }

    return `${formatDateFromString(booking?.start || '', DateFormat.DATETIME_WEEKDAY_FORMAT)}
      - ${formatDateFromString(booking?.end || '', DateFormat.DATETIME_WEEKDAY_FORMAT)}`
  }

  const { bookings = [] } = props;

  return (
    <div className='pr-4 pl-4 place-content-center bg-neutral-100 rounded-2xl'>
      <div className='grid grid-cols-1 pt-2'>
        {bookings.map(booking => (
          <div className='pb-2 mt-2' key={`booking-${booking.id}`}>
            <DashboardBookingCard
              booking={booking}
              profile={booking?.parent}
              getDateString={getDateString}
              linkComponent={<BookingLinkComponent booking={booking}/>}
            />
          </div>
        ))}
        <div className='pb-2 mt-2'>
          <Link className='block py-1 my-1 text-sm' to={`/app${Routes.bookings.root}?filterType=all_date`} external>
            {t('pages.sitter.dashboard.bookings.viewAll')}
            <FontAwesomeIcon icon={faAngleRight} className='pl-2 m-[-1px]'/>
          </Link>
        </div>
      </div>
    </div>
  );
};
